import { clients } from "@/shared/dtos/clients";

export class clients_local_service {
  public static local_client_storage: string = "mi_user_data_v1";

  public static load(): clients | null {
    try {
      var raw = localStorage.getItem(this.local_client_storage);
      if (!raw) { return null; }

      // Primer parse
      var parsed: any;
      try {
        parsed = JSON.parse(raw);
      } catch (_e) {
        return null;
      }

      // Si tras el primer parse sigue siendo string, es que estaba doble-serializado
      if (typeof parsed === "string") {
        try {
          parsed = JSON.parse(parsed);
        } catch (_e2) {
          // No es JSON válido: abortamos
          return null;
        }
      }

      return new clients(parsed);
    } catch (_e) {
      return null;
    }
  }

  public static save(model: clients): void {
    try {
      var payload: any;
      if (model && typeof (model as any).toJson === "function") {
        payload = (model as any).toJson();
      } else {
        payload = model;
      }

      // Si toJson() devuelve string JSON, guárdalo tal cual (sin volver a stringify)
      if (typeof payload === "string") {
        // Comprobamos si parece JSON para evitar guardar texto suelto
        var trimmed = payload.replace(/^\s+|\s+$/g, "");
        var looksJson = (trimmed.charAt(0) === "{" && trimmed.charAt(trimmed.length - 1) === "}") ||
                        (trimmed.charAt(0) === "[" && trimmed.charAt(trimmed.length - 1) === "]");
        if (looksJson) {
          localStorage.setItem(this.local_client_storage, payload);
        } else {
          // No es JSON, lo envolvemos
          localStorage.setItem(this.local_client_storage, JSON.stringify(payload));
        }
      } else {
        // Objeto: stringify normal
        localStorage.setItem(this.local_client_storage, JSON.stringify(payload));
      }
    } catch (_e) { /* noop */ }
  }

  public static remove(): void {
    try { localStorage.removeItem(this.local_client_storage); } catch (_e) { /* noop */ }
  }
}

export const ClientsLocalService = clients_local_service;
